import StudyModules from './StudyModules';

export default StudyModules;
